
export const environment = {
  name: 'test',
  production: false,
  recordDetailsEndpoint: '',
  environment: "test",
  tenantId: "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
  clientId: "6c65ddf5-3dc3-445b-bd6c-88b3456b4d71",
  baseUrl: "https://welexe-api-dev.azure.chevron.com",
  apiUrl: "https://welexe-api-dev.azure.chevron.com/api/v1/",
  ApiKey: "",
  apiScope: '',
  msalEnable: true,
  redirectUri: "/",
  requiredGroupId: "857ab3e2-2a3a-430d-a470-3b10e389c902",  // Set your AD Group Object ID here for role-based access control
};